import Skeleton from "react-loading-skeleton";

import { Keyword } from "../../api/Api";
import NoData from "../containers/NoData";
import styles from "./FocusKeyword.module.scss";

type FocusKeywordProps = {
  data: Keyword | null;
  isLoadingFocusKeywordDetail: boolean;
  isLoading: boolean;
};

const FocusKeyword = ({
  data,
  isLoadingFocusKeywordDetail,
}: FocusKeywordProps) => {
  const focusKeywordData = [
    {
      label: "Current Position",
      value: data?.now_pos || "N/A",
    },
    {
      label: "Search Volume",
      value: data?.search_vol || "N/A",
    },
    {
      label: "Visits",
      value: data?.current_traffic || "N/A",
    },
    {
      label: "Projected",
      value: data?.proj_traffic || "N/A",
    },
    {
      label: "Projected top",
      value: data?.proj_top_traffic || "N/A",
    },
  ];
  if (!isLoadingFocusKeywordDetail && !data) {
    return <NoData title="No Focus Keyword"></NoData>;
  }

  return (
    <div className={styles.focusKeyword}>
      {focusKeywordData.map((item, index) => (
        <div key={index} className={styles.focusKeywordBlock}>
          <span className={styles.focusKeywordLabel}>{item.label}</span>
          <div className={styles.focusKeywordValues}>
            <span>
              {isLoadingFocusKeywordDetail ? (
                <span className={styles.focusKeywordValue}>
                  <Skeleton width={50} />
                </span>
              ) : (
                <span className={styles.focusKeywordValue}>{item.value}</span>
              )}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FocusKeyword;
